module.exports = __webpack_public_path__ + "static/media/retail.8f647992.jpg";